var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "overview-tab"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 p-0"
  }, [_c('nav', [_c('div', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "nav-tab",
      "role": "tablist"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.isActiveProfileTab
    },
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "nav-home-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#nav-home",
      "type": "button",
      "role": "tab",
      "aria-controls": "nav-home",
      "aria-selected": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('tab-changed', $event);
      }
    }
  }, [_vm._v(" Overview ")]), _c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.isActiveEventHighlightsTab
    },
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "nav-event-highlights-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#nav-event-highlights",
      "type": "button",
      "role": "tab",
      "aria-controls": "nav-event-highlights",
      "aria-selected": "false"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('tab-changed', $event);
      }
    }
  }, [_vm._v(" Video Highlights ")]), _c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.isActiveActivityTab
    },
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "nav-contact-tab3",
      "data-bs-toggle": "tab",
      "data-bs-target": "#nav-activities",
      "type": "button",
      "role": "tab",
      "aria-controls": "nav-activities",
      "aria-selected": "false"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('tab-changed', $event);
      }
    }
  }, [_vm._v(" ACTIVITIES ")]), _vm.showGameShop ? _c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.isActiveInGameShopTab
    },
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "nav-in-game-shop-tab3",
      "data-bs-toggle": "tab",
      "data-bs-target": "#nav-in-game-shop",
      "type": "button",
      "role": "tab",
      "aria-controls": "nav-in-game-shop",
      "aria-selected": "false"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('tab-changed', $event);
      }
    }
  }, [_vm._v(" In Game Shop ")]) : _vm._e(), _vm.showGifting ? _c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.isActiveGiftingTab
    },
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "nav-gifting-tab3",
      "data-bs-toggle": "tab",
      "data-bs-target": "#nav-gifting",
      "type": "button",
      "role": "tab",
      "aria-controls": "nav-gifting",
      "aria-selected": "false"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('tab-changed', $event);
      }
    }
  }, [_vm._v(" Gifting ")]) : _vm._e()])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }